import cn from 'classnames'
import { type JSX, type PropsWithChildren } from 'react'

import styles from './styles.module.css'

interface LabelProps {
  theme?: 'dark' | 'light'
}

const Label = ({ children, theme = 'dark' }: PropsWithChildren<LabelProps>): JSX.Element => {
  return (
    <div
      className={cn(styles.label, {
        [styles['theme-dark']]: theme === 'dark',
        [styles['theme-light']]: theme === 'light'
      })}
    >
      {children}
    </div>
  )
}

export default Label
